export const DSN = 'https://fccaf7b492d94e11808b3c06a69267a5@o926465.ingest.sentry.io/5899632'